import styled from 'styled-components'

const Logo = styled.img`
  height: 36px;
`

export default Logo
